import React from "react"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IQuestion, IDate } from "../../../models"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"
import { grey800 } from "material-ui/styles/colors"
import PunchQuestionAnswerDetailContent from "./PunchQuestionAnswerDetailContent"
interface IProps {
    punchDateTimeLocal: IDate
    imageS3Url: string
    questions: IQuestion[]
    btn1Ids: string[]
    btn2Ids: string[]
    handleClose(): void
}

const PunchQuestionAnswerDetailDialog: React.SFC<IProps> = (props: IProps) => {
    return (
        <Dialog
            open
            autoScrollBodyContent
            title={strings.formatString(strings.Punch_Questions_for_x, moment(timeHelper.keepConvertUTCToLocal(props.punchDateTimeLocal)).format("hh:mma MM/DD/YYYY"))}
            actions={< FlatButton label={strings.OK} primary onTouchTap={props.handleClose} />}
            bodyStyle={{ color: grey800 }}
        >
            <PunchQuestionAnswerDetailContent
                imageS3Url={props.imageS3Url}
                questions={props.questions}
                btn1Ids={props.btn1Ids}
                btn2Ids={props.btn2Ids}
            />
        </Dialog >
    )
}

export default PunchQuestionAnswerDetailDialog

